import { render, staticRenderFns } from "./MesoFoodForm.vue?vue&type=template&id=46b4b57c"
import script from "./MesoFoodForm.vue?vue&type=script&lang=js"
export * from "./MesoFoodForm.vue?vue&type=script&lang=js"
import style0 from "./MesoFoodForm.vue?vue&type=style&index=0&id=46b4b57c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports